import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=bde164ce"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde164ce')) {
      api.createRecord('bde164ce', component.options)
    } else {
      api.reload('bde164ce', component.options)
    }
    module.hot.accept("./Block.vue?vue&type=template&id=bde164ce", function () {
      api.rerender('bde164ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/SystemManage/HomePage/Block.vue"
export default component.exports